// src/constants/typography.ts

export const txt = {
  main: 'font-medium text-[#2b2b2b] dark:text-[#F8FAFF]',
  sub: 'font-medium text-[rgba(43,43,43,0.76)] dark:text-[rgba(232,236,255,0.88)]',
  muted: 'font-medium text-[rgba(43,43,43,0.58)] dark:text-[rgba(213,220,255,0.72)]',
  heading: 'font-semibold text-[#1f1f1f] dark:text-[#F8FAFF]',
  strong: 'font-semibold text-[#1f1f1f] dark:text-[#FFFFFF]',
  button: 'font-semibold text-[#1f1f1f] dark:text-[#FFFFFF]',

  pageKicker: 'text-[11px] font-black uppercase tracking-[0.24em] text-[#766E63] dark:text-[#D8E1FF]',
  pageTitle: 'text-[28px] font-extrabold leading-none text-[#22313A] dark:text-[#FCFDFF] sm:text-[30px]',
  pageBody: 'text-[13px] leading-5 text-[#5F5A52] dark:text-[#EEF2FF]',
  cardTitle: 'text-[17px] font-extrabold text-[#2f3d45] dark:text-[#F8FAFF] sm:text-[18px]',
  cardBody: 'text-xs text-[#7b7267] dark:text-[#D7DCF8]',
  statLabel: 'text-[10px] font-black uppercase tracking-[0.16em] text-[#8c8376] dark:text-[#C6CEF7]',
};
